export default function getClientVisibleKey() {
    return '6LfyDgAVAAAAAPCX6GqTLqZTBFr_ZmUEROdYeDO_';
}
